import { isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import type { MessageFormData } from 'mk2/apps/bazaar/components/MessageForm';
import { ContactSellerForAnonymous } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerForAnonymous';
import { ContactSellerForBuyer } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerForBuyer';
import { ContactSellerForSeller } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerForSeller';
import { BazaarMessageEntity, BuyerEntity, ProductEntity } from 'mk2/apps/bazaar/schemas';
import { Plan, UserEntity } from 'mk2/schemas';
import React from 'react';

interface OwnProps {
    className?: string;
    product: ProductEntity;
    buyers: BuyerEntity[];
    messages: BazaarMessageEntity[];
    sellerPhone?: string;

    requestUser: UserEntity;
    requestUserPermissions: string[];
    initiallyOpened?: boolean;
    isLoadingProductDetails?: boolean;

    onSendMessage(productId: number, productSlug: string, values: MessageFormData);
    onScrollToMessages(event: React.MouseEvent<HTMLAnchorElement>);
}

export const ContactSeller: React.FunctionComponent<OwnProps> = React.memo(({
    className,
    product, buyers, messages,
    requestUser,
    requestUserPermissions,
    initiallyOpened = false,
    isLoadingProductDetails = false,
    onSendMessage,
    onScrollToMessages,
    sellerPhone,
}) => {
    const isSeller = isAuthenticatedAs(requestUser, product.seller?.user);
    const isAnonymous = !isAuthenticated(requestUser);

    const canSendMsg = true;

    sellerPhone = product.seller?.showSellerPhone
        ? sellerPhone
        : null;
    const eshopUrl = product.seller?.user.activePlan === Plan.PRO
        ? product.eshopUrl
        : null;

    if (isAnonymous) {
        return (
            <ContactSellerForAnonymous
                product={product}
                canSendMsg={canSendMsg}
                sellerPhone={sellerPhone}
                eshopUrl={eshopUrl}
            />
        );
    } else if (isSeller) {
        return (
            <ContactSellerForSeller
                product={product}
                sellerPhone={sellerPhone}
                eshopUrl={eshopUrl}
            />
        );
    } else { // isBuyer (or pontential buyer)
        const myBuyer = buyers.find((b) => isAuthenticatedAs(requestUser, b.user));
        const buyerMessages = myBuyer ? messages.filter((m) => m.buyer.id === myBuyer.id) : [];

        return (
            <ContactSellerForBuyer
                product={product}
                canSendMsg={canSendMsg}
                sellerPhone={sellerPhone}
                eshopUrl={eshopUrl}
                buyerUser={requestUser}
                buyerMessages={buyerMessages}
                onSendMessage={onSendMessage}
                onScrollToMessages={onScrollToMessages}
                hasMessageFormInitiallyOpen={initiallyOpened}
            />
        );
    }
});
